import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "container"]
  static values = { purchaseDate: String, price: Number }

  connect() {
    this.#render()
  }

  render() {
    this.#render()
  }

  #render() {
    const lifespan = parseInt(this.inputTarget.value)

    if (!lifespan || lifespan < 1 || !this.purchaseDateValue) {
      this.containerTarget.classList.add("hidden")
      return
    }

    this.containerTarget.classList.remove("hidden")

    const chart = window.Chartkick?.charts["depreciation-chart"]
    chart?.updateData(this.#buildData(lifespan))
  }

  #buildData(lifespan) {
    const start = new Date(this.purchaseDateValue)
    const price = this.priceValue
    const points = []

    for (let year = 0; year <= lifespan; year++) {
      const d = new Date(start)
      d.setFullYear(d.getFullYear() + year)
      const value = Math.round(price * (1 - year / lifespan) * 100) / 100
      points.push([d.toISOString().split("T")[0], value])
    }

    return points
  }
}
